import {
  Account,
  AccountsPage,
  AccountsSummary,
  NewAccount,
  UpdateAccount,
} from '../../../models/accounts';
import AccountingApiClient from '../base-client';
import { PageRequest } from './types';

class AccountsApi extends AccountingApiClient<Account, AccountsPage> {
  private buildFilter = (filter: PageRequest['filter']): string | undefined => {
    if (!filter) {
      return;
    }

    const expressions = [];

    if (filter.name) {
      expressions.push(`contains(name,'${filter.name}')`);
    }

    if (filter.type) {
      expressions.push(`type eq '${filter.type}'`);
    }

    if (filter.status) {
      expressions.push(`status eq '${filter.status}'`);
    }

    return expressions.join(' and ');
  };

  public constructor() {
    super('/accounts');
  }

  public async getPage({
    page,
    perPage,
    filter,
  }: PageRequest): Promise<AccountsPage> {
    let url = `${this.baseUrl}?`;

    if (page) {
      url = `${url}&page=${page}`;
    }

    if (perPage) {
      url = `${url}&per_page=${perPage}`;
    }

    const filterExpression = this.buildFilter(filter);

    if (filterExpression) {
      url = `${url}&filter=${filterExpression}`;
    }

    return super.httpList(url);
  }

  public async get(id: string): Promise<Account> {
    return super.httpGet(`${this.baseUrl}/${id}`);
  }

  public async create(account: NewAccount): Promise<Account> {
    return super.httpPost<NewAccount>(this.baseUrl, account);
  }

  public async update({ id, ...body }: UpdateAccount): Promise<Account> {
    return super.httpPut(`${this.baseUrl}/${id}`, body);
  }

  public async delete(id: string): Promise<void> {
    return super.httpDelete(`${this.baseUrl}/${id}`);
  }

  public async getSummary(
    filter?: PageRequest['filter']
  ): Promise<AccountsSummary> {
    let url = `${this.baseUrl}/summary?`;

    if (filter) {
      const filterExpression = this.buildFilter(filter);
      if (filterExpression) {
        url = `${url}&filter=${filterExpression}`;
      }
    }

    return this.fetch<AccountsSummary>(url, { method: 'GET' });
  }
}

const accountsApi = new AccountsApi();

export default accountsApi;
